export default {
  addShopSuccess: 'Artículo agregado con éxito',
  addShopFail: 'No se pudo agregar el artículo',
  getCartDataFail:
    'No se pudieron obtener los artículos del carrito de compras',
  hint: 'Sugerencia',
  delConfirmProduct: '¿Estás seguro de que quieres eliminar este producto?',
  confirm: 'Confirmar',
  cancel: 'Cancelar',
  productInfo: 'Detalles del producto',
  unitPrice: 'Precio unitario',
  num: 'Cantidad',
  subtotal: 'Subtotal',
  action: 'Acción',
  productName: 'Nombre del producto',
  splitProduct: 'Dividir producto',
  split: 'Dividir',
  allSelect: 'Seleccionar todo',
  delProduct: 'Eliminar seleccionado',
  selected: 'Seleccionado',
  piece: 'Artículo(s)',
  total: 'Total',
  productTotal: 'Sin incluir el costo de envío internacional',
  orderPay: 'Pagar',
  orderTotal: 'Total del pedido',
  goCartPay: 'Ver carrito',
  moreView: 'Más artículos del carrito',
  noSelectText: 'Aún no has seleccionado ningún producto',
  paySuccess: '¡Pago exitoso!',
  returnPayment: 'Volver para continuar el pago',
  service: 'Servicio',
  goodsMinNumErrTips:
    'Este producto requiere una cantidad mínima de compra de {num}, puedes elegir diferentes especificaciones según tus necesidades.',
  balckShop: 'La tienda está en lista negra',
  forbidBuy: 'Tienda de riesgo, prohibido comprar',
  riskTip: 'Tiendas de riesgo, compra con precaución',
  riskReminder: 'Recordatorio de riesgo',
  blackenedShop: 'Tienda en lista negra',
  riskProducts: 'Productos de riesgo',
  riskMsg1:
    'Es posible que haya algún riesgo asociado con los productos que envías. Por la seguridad de tus finanzas, en este momento no podemos ofrecerte servicios de pedido en línea. Para más información, contacta al servicio al cliente o a la compra especializada.',
  riskMsg2:
    'Es posible que los productos que envías presenten algún riesgo en el envío. Por la seguridad de tus finanzas, temporalmente no podemos ofrecerte servicios de pedido en línea. Para más información, contacta al servicio al cliente en línea.',
  riskMsg3:
    'El producto que estás comprando puede ser un artículo especializado o de marca. No tenemos la capacidad de autenticar su autenticidad y solo podemos ofrecer servicios de compra y control de calidad básico. Cualquier riesgo potencial debe ser asumido por ti.',
  continueToBuy: 'Continuar comprando otros',
  buyOthers: 'Comprar otros',
  continuePurchasing: 'Continuar comprando'
};
